@let currentElementResponse = currentElement$();

@if(currentElementResponse.success) {
@let currentElement = currentElementResponse.payload;
@let styleId = currentElement.styles;
@let value = currentElement.value;
@let tag = currentElement.tag;
<div
    appClickOutside  
    [ngClass]="customClass"
    class="editable-container" 
    [isActive]="showEditButton && isEditMode$()"
    (clickOutside)="onClickOutside()">
    
    <div class="button-wrapper" (click)="onEdit()">
        @if(showEditButton && isEditMode$()) {
        <div class="editable-actions admin-theme">
            <button mat-mini-fab (click)="openConfig($event, 'meta')">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-mini-fab (click)="openConfig($event, 'button')">
                <mat-icon>settings</mat-icon>
            </button>
        </div>
        }

        @if(metaConfigOpen) {
        <app-meta-config 
            [elemId]="elemId()"
            [styleId]="styleId" 
            [CSDElementRef]="buttonElementRef()"
            [eType]="eType"
            (closePanel)="closeAllConfig()">
        </app-meta-config>
        }
        @else if(buttonConfigOpen) {
        <app-button-actions 
            [elemId]="elemId()" 
            (closePanel)="closeAllConfig()">
        </app-button-actions>
        }

        @if(tag == 'mat-flat-button') {
        <button #buttonElement class="button-emphasis" mat-flat-button [ngStyle]="styles$()" (click)="!isEditMode$() && onClick()">
            <span [attr.contenteditable]="isEditMode$()" (blur)="onBlur($event)">{{ value }}</span>
        </button> }
        @else if(tag == 'mat-raised-button') {
        <button #buttonElement class="button-emphasis" mat-raised-button [ngStyle]="styles$()" (click)="!isEditMode$() && onClick()">
            <span [attr.contenteditable]="isEditMode$()" (blur)="onBlur($event)">{{ value }}</span>
        </button> }
    

    </div>
</div>
}
@else {
<p>Element konnte nicht geladen werden</p>
}